<template>
  <div class="w-full">
    <page-header v-if="$store.state.AppActiveUser.userRole === 'merchant'" :title="$t('Notifications')">
      <shipblu-button :textButton="$t('Mark All As Read')" @click="updateNotifications()" />
    </page-header>
    <shipblu-button v-else class="ml-auto mb-4" :textButton="$t('Mark All As Read')" @click="updateNotifications()" />

    <!-- Notifications List -->
    <div class="flex flex-col gap-[8px]">
      <div class="flex items-start justify-between px-[20px] py-[16px] cursor-pointer rounded-[7px] border-0 border-b-[1px] border-solid border-beluga"
        :class="notification.status === 'read' ? 'bg-white' : 'bg-carte-blanche'" v-for="(notification, index) in notifications" :key="index" @click="openNotification(notification)">
        <div class="flex flex-col gap-[6px]">
          <div class="flex items-center gap-2">
            <p class="text-young-night text-[20px]">{{ notification.subject }}</p>
            <small v-if="!isExpired(notification.created)" class="text-red font-normal ml-1">{{ notification.link !== null && notification.link.includes('s3.amazonaws.com') ? $t('Expired') : ''}}</small>
          </div>
          <p class="text-[14px] text-industrial-revolution">{{ notification.body }}</p>
        </div>
        <p class="text-silver text-[14px] whitespace-nowrap leading-[30px]">{{timeAgoOrDate(notification.created) }}</p>
      </div>
      <div v-if="hasLoadedOnScroll" class="flex items-center justify-center h-16">
        <div class="w-8 h-8 rounded-full animate-spin border-2 border-solid border-primary border-t-transparent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AXIOS  from '../../http/axios/index.js'
import common from '@/assets/utils/common'

export default {
  data () {
    return {
      disable: false,
      scrollPosition: 0,
      isBottomReached: false,
      hasLoadedOnScroll: false,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      },
      notifications: [],
      offset: '',
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      releaseVersion: process.env.VUE_APP_RELEASE_VERSION
    }
  },
  methods: {
    handleScroll (event) {
      const el = event.target
      const scrollTop = el.scrollTop
      const scrollHeight = el.scrollHeight
      const clientHeight = el.clientHeight
      this.scrollPosition = scrollTop + clientHeight
      this.isBottomReached = this.scrollPosition >= scrollHeight - 10

      if (this.isBottomReached && !this.hasLoadedOnScroll && !this.disable) {
        this.hasLoadedOnScroll = true
        setTimeout(() => {
          this.loadNotifications(false)
        }, 500)
      }
    },
    isExpired (date) {
      const expiredDate = new Date(date)
      expiredDate.setHours(expiredDate.getHours() + 1)
      return expiredDate > new Date()
    },
    loadNotifications (isLoading = true) {
      if (isLoading) this.$vs.loading()
      AXIOS.get(`${process.env.VUE_APP_API_URL}/api/v2/buzzer/in-app/?last_evaluated_key=${this.offset}&limit=${this.maximumItems}`, {headers: this.headers}, {
      })
        .then((response) => {
          this.notifications = [...this.notifications, ...response.data.results]
          this.notifications.forEach(element => {
            element.time = (new Date() - new Date(element.created)) / (1000 * 60 * 60) 
          })
          this.disable = response.data.next === null
          this.offset = response.data.next
          if (isLoading) this.$vs.loading.close()
          this.hasLoadedOnScroll = false
        })
        .catch((error) => {
          common.notifyResponseError(this, error)
          if (isLoading) this.$vs.loading.close()
        })
    },
    openNotification (notification) {
      this.$vs.loading()
      if (this.$store.state.AppActiveUser.userRole === 'merchant' && this.releaseVersion !== 'staging') {
        const userMerchant = JSON.parse(localStorage.getItem('userMerchant'))
        const user = JSON.parse(localStorage.getItem('merchant'))
        if (notification.subject.includes('New Bank Deposit')) {
          this.$mixpanel.track('INAPP_BANK', {
            merchant_name: user.name || '',
            merchant_email: userMerchant.email,
            source: /(android)/i.test(navigator.userAgent)
          })
        }
        switch (notification.subject) {
        case 'Orders Upload Completed with Errors':
          this.$mixpanel.track('INAPP_UPLOAD_ERROR', {
            merchant_name: user.name || '',
            merchant_email: userMerchant.email,
            source: /(android)/i.test(navigator.userAgent)
          })
          break
        case 'Orders Upload Successfully Completed':
          this.$mixpanel.track('INAPP_UPLOAD_SUCCESS', {
            merchant_name: user.name || '',
            merchant_email: userMerchant.email,
            source: /(android)/i.test(navigator.userAgent)
          })
          break
        case 'Your export is complete!':
          this.$mixpanel.track('INAPP_EXPORT', {
            merchant_name: user.name || '',
            merchant_email: userMerchant.email,
            source: /(android)/i.test(navigator.userAgent)
          })
          break
        case 'A new statement is available':
          this.$mixpanel.track('INAPP_STATEMENT', {
            merchant_name: user.name || '',
            merchant_email: userMerchant.email,
            source: /(android)/i.test(navigator.userAgent)
          })
          break 
        default:
          break
        }
      }
      this.updateNotifications(notification)
    },
    updateNotifications (notification) {
      this.$vs.loading()
      const notifications = []
      if (notification && notification.status === 'unread') {
        notifications.push({
          created: notification.created,
          status: 'read'
        })
      } else {
        this.notifications.forEach(element => {
          if (element.status === 'unread') {
            element.status = 'read'
          }
        })
        localStorage.removeItem('notifications')
      }
      AXIOS.patch(`${process.env.VUE_APP_API_URL}/api/v2/buzzer/in-app/`, notifications.length > 0 ? notifications : this.notifications, {headers: this.headers}, {
      })
        .then(() => {
          this.notifications.forEach(item => {
            item.status = 'read'
          })
          localStorage.setItem('notifications', localStorage.getItem('notifications') - notifications.length)
          if (notification.link) {
            this.redirctRouter(notification)
          }
          this.$vs.loading.close()
        })
        .catch((error) => {
          common.notifyResponseError(this, error)
          this.$vs.loading.close()
        })
    },
    redirctRouter (notification) {
      if (notification.link !== null && (this.isExpired(notification.created) || !notification.link.includes('s3.amazonaws.com'))) {
        if (notification.link.startsWith('https') || notification.link.startsWith('http')) {
          window.open(notification.link, '_self')
        } else {
          this.$router.push({
            path: `/${this.$i18n.locale}${notification.link}`
          }).catch(() => {})
        }
      }
    },
    viewNotifications () {
      this.$router.push({
        name: `${this.$store.state.AppActiveUser.userRole}-notifications`
      }).catch(() => {})
    },
    timeAgoOrDate  (dateString) {
      const now = new Date()
      const past = new Date(dateString)
      const seconds = Math.floor((now.getTime() - past.getTime()) / 1000)
      const days = Math.floor(seconds / 86400)
      if (days > 30) {
        const options = {
          month: 'short',
          day: 'numeric',
          year: now.getFullYear() !== past.getFullYear() ? 'numeric' : undefined
        }
        return past.toLocaleDateString(undefined, options) 
      }
      const intervals = [
        { label: 'w', seconds: 604800 },
        { label: 'd', seconds: 86400 },
        { label: 'h', seconds: 3600 },
        { label: 'm', seconds: 60 },
        { label: 's', seconds: 1 }
      ]
      for (const interval of intervals) {
        const count = Math.floor(seconds / interval.seconds)
        if (count >= 1) {
          return `${count}${interval.label} ago`
        }
      }

      return 'just now'
    }
  },
  mounted () {
    this.loadNotifications()
    const scrollContainerElement = document.getElementById('scrollContainer')
    if (scrollContainerElement) {
      scrollContainerElement.addEventListener('scroll', this.handleScroll)
    }
  },
  beforeDestroy () {
    const scrollContainerElement = document.getElementById('scrollContainer')
    if (scrollContainerElement) {
      scrollContainerElement.removeEventListener('scroll', this.handleScroll)
    }
  }
}
</script>